<div
  class="modal-dialog modal-dialog-centered"
  style="max-width: none !important"
>
  <div class="modal-content">
    <div class="modal-body">
      <h5 class="text-center mb-4">
        {{ 'sensitiveData.title' | translate }}
      </h5>
      <table
        class="table table-bordered"
        *ngIf="
          sensitiveInformationTypes && sensitiveInformationTypes.length !== 0
        "
      >
        <thead>
          <tr>
            <th style="width: 25%">{{ 'sensitiveData.type' | translate }}</th>
            <th style="width: 30%">
              {{ 'sensitiveData.nElements' | translate }}
            </th>
            <th>{{ 'sensitiveData.confidence' | translate }}</th>
            <th>{{ 'sensitiveData.group' | translate }}</th>
            <th>{{ 'sensitiveData.severity' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let sensitiveInformationType of sensitiveInformationTypes"
          >
            <td>{{ sensitiveInformationType.typeName }}</td>
            <td>{{ sensitiveInformationType.count }}</td>
            <td>{{ sensitiveInformationType.confidence }}</td>
            <td>{{ sensitiveInformationType.group }}</td>
            <td>
              <span
                class="badge"
                [ngClass]="{
                  'outline-badge-success':
                    sensitiveInformationType.severity?.toLowerCase() === 'low',
                  'outline-badge-warning':
                    sensitiveInformationType.severity?.toLowerCase() === 'mid',
                  'outline-badge-danger':
                    sensitiveInformationType.severity?.toLowerCase() === 'high'
                }"
              >
                {{ sensitiveInformationType.severity }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="
          !sensitiveInformationTypes || sensitiveInformationTypes.length === 0
        "
      >
        {{ 'sensitiveData.noData' | translate }}
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-primary" (click)="cancel()">
        {{ 'accept' | translate }}
      </button>
    </div>
  </div>
</div>
